import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Router from "./route/root.route";
import "antd/dist/antd.css";
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
    <BrowserRouter>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Router />
      </GoogleOAuthProvider>
    </BrowserRouter>
  );
}

export default App;
